import { BarChart, Checklist, Grade, Home, ListAlt } from "@mui/icons-material";

export const getMenuIcon = (icon) => {
	switch (icon) {
		case 'ListIcon':
			return () => <ListAlt/>
		case 'GradeIcon':
			return () => <Grade/>
		case 'ReportsIcon':
			return () => <BarChart/>
		case 'HomeIcon':
			return () => <Home/>
		case 'ChecklistIcon':
			return () => <Checklist/>
		default:
			return
	}
}